module.exports = __webpack_public_path__ + "static/media/energy3.7e5b19ba.jpeg";